module.exports = __webpack_public_path__ + "img/lock_green.e67e803c.png";